// extracted by mini-css-extract-plugin
export default {"pageNotFound":"PageNotFound_pageNotFound__Yf8et","homeLink":"PageNotFound_homeLink__BD3nY"};